import * as React from "react";
import { SVGProps } from "react";
const SvgArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.022 6.837c2.426 1.793 5.04 4.478 7.767 7.983a.999.999 0 1 1-1.578 1.228c-2.175-2.795-4.258-5.033-6.207-6.676V24.5a1 1 0 0 1-2 0V9.366c-1.951 1.643-4.036 3.884-6.215 6.682a1 1 0 0 1-1.578-1.228c2.728-3.506 5.342-6.192 7.767-7.982a1.712 1.712 0 0 1 2.044 0v-.001Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgArrowUp;
